import { render, staticRenderFns } from "./linkDialog.vue?vue&type=template&id=31c1293e&scoped=true&"
import script from "./linkDialog.vue?vue&type=script&lang=js&"
export * from "./linkDialog.vue?vue&type=script&lang=js&"
import style0 from "./linkDialog.vue?vue&type=style&index=0&id=31c1293e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c1293e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31c1293e')) {
      api.createRecord('31c1293e', component.options)
    } else {
      api.reload('31c1293e', component.options)
    }
    module.hot.accept("./linkDialog.vue?vue&type=template&id=31c1293e&scoped=true&", function () {
      api.rerender('31c1293e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aliApp/xcxPos/home/components/linkDialog.vue"
export default component.exports